import { Stack, Typography } from '@mui/material';
import MyAvailabilityV4 from 'app/calendarV4/availability/MyAvailability';
import MyAvailabilityCreateActionV4 from 'app/calendarV4/availability/MyAvailabilityCreateAction';
import OCalendar from 'app/ocalendar/OCalendar';
import MyAvailability from 'app/profile/availability/MyAvailability';
import MyAvailabilityCreateAction from 'app/profile/availability/MyAvailabilityCreateAction';
import SettingsKey from 'app/profile/settings/utils/settingsTypes';
import { useSettingValue } from 'app/profile/settings/utils/useSettingValue';
import { useAuthLicenseAddOns } from 'common/features/licenseFeatures/useAuthLicenseAddOns';
import useFlexBoxStyles from 'common/flexBox';
import LayoutForm from 'common/layouts/LayoutForm';
import { ValidatorForm } from 'react-material-ui-form-validator';

const UserAvailability = ({ userData }) => {
    const { userId, title } = userData;
    const calendarVersion = useSettingValue(SettingsKey.CALENDAR_VERSION) ?? 3;
    const { classes: flexBox, cx } = useFlexBoxStyles();
    const isAuthorize = useAuthLicenseAddOns();
    const iCalendar = isAuthorize(['oneToOne.iCalendar']);

    return (
        <LayoutForm
            size="big"
            customClasses={flexBox.vH70}
            extra={
                <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
                    <Stack sx={{ minWidth: 0 }}>
                        <Typography direction="row" fontWeight="bold" variant="onliveH3" noWrap>
                            {title?.toUpperCase()}
                        </Typography>
                    </Stack>
                    <Stack>
                        {calendarVersion === 3 ? (
                            <MyAvailabilityCreateAction userData={userData} />
                        ) : (
                            <MyAvailabilityCreateActionV4 userData={userData} />
                        )}
                    </Stack>
                </Stack>
            }
        >
            <Stack direction="column" className={cx(flexBox.overflowXHidden, flexBox.scrollbarNone, flexBox.h100)}>
                {iCalendar ? (
                    calendarVersion === 3 ? (
                        <MyAvailability userData={userData} />
                    ) : (
                        <MyAvailabilityV4 userData={userData} />
                    )
                ) : (
                    <ValidatorForm onSubmit={() => {}}>
                        <OCalendar userId={userId} isReadOnly={false} scrollable={true} />
                    </ValidatorForm>
                )}
            </Stack>
        </LayoutForm>
    );
};

export default UserAvailability;
